import { useCallback, useEffect, useState } from 'react';
import type { OrgNode } from '../../../services/orgs/interfaces';
import OrgsService from '../../../services/orgs';
import { extractErrorMessage } from '../../../util/errorMessage';

export default function useOrgData({
  raiseFundraiserId,
  refreshKyb,
}: {
  raiseFundraiserId?: number;
  refreshKyb: Symbol;
}): {
  org?: OrgNode;
  errorMessage?: string;
  isFinished: boolean;
} {
  const [org, setOrg] = useState<OrgNode>();
  const [orgId, setOrgId] = useState<string>();
  const [errorMessage, setErrorMessage] = useState<string>();
  const [isFinished, setIsFinished] = useState(false);

  const getOrgIdFromRaiseFundraiserId = useCallback(async () => {
    if (raiseFundraiserId) {
      try {
        const _orgId = await OrgsService.orgId(raiseFundraiserId);
        setOrgId(_orgId);
      } catch (error) {
        setErrorMessage(extractErrorMessage(error));
      }
    }
  }, [raiseFundraiserId]);

  const gatherData = useCallback(async () => {
    if (!!orgId && org === undefined) {
      try {
        const retrievedOrg = await OrgsService.getOrgNode(orgId);
        setOrg(retrievedOrg);
      } catch (e) {
        setErrorMessage(extractErrorMessage(e));
      } finally {
        setIsFinished(true);
      }
    }
  }, [orgId, org]);

  useEffect(() => {
    getOrgIdFromRaiseFundraiserId();
  }, [getOrgIdFromRaiseFundraiserId]);

  useEffect(() => {
    gatherData();
  }, [gatherData, refreshKyb]);

  return { org, errorMessage, isFinished };
}
